/* eslint-disable import/no-unused-modules -- This is the entry point of the app. */
import { configure as configureMobx } from 'mobx'
import ReactDOM from 'react-dom/client'

import { App } from './App'
import { RouteProvider } from './router'
import { getOrCreateStore, type RootStoreEnvironment } from './stores/rootStore'
import { SentryService } from './utils/SentryService'
import { StrictMode } from 'react'

/*
  Used for Cypress in CI
*/
const isStrictMode = import.meta.env.VITE_STRICT_MODE !== 'false';

function bootstrapApp() {
  configureMobx({
    enforceActions: 'always',
    // https://mobx.js.org/refguide/api.html#configure
    computedRequiresReaction: true,
    // observableRequiresReaction: true,
    // reactionRequiresObservable: true,
  })
  const rootStoreEnvironment: RootStoreEnvironment = {
    fetch: window.fetch.bind(window),
    setTimeout: window.setTimeout.bind(window),
    clearTimeout: window.clearTimeout.bind(window),
    // ENV,
  } as const
  const rootStore = getOrCreateStore(rootStoreEnvironment)
  Object.assign(window, { rootStore })
  return rootStore
}

function renderApp(rootElement: HTMLElement | null) {
  if (!rootElement) {
    throw Error('No root element')
  }

  const root = ReactDOM.createRoot(rootElement);

  const rootStore = bootstrapApp()

  const AppWithRouteProvider = (
    <RouteProvider>
      <App {...{ ...rootStore }} />
    </RouteProvider>
  )

  root.render(
    isStrictMode ? (
      <StrictMode>
        {AppWithRouteProvider}
      </StrictMode>
    ) : AppWithRouteProvider
  )
}

SentryService.initSentry()

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason as string
  console.warn(`Error - unhandled promise rejection: ${reason}`, { event })
})
window.addEventListener("error", (event) => {
  console.warn("Uncaught Error occurred: ", event.error);
})
document.addEventListener('DOMContentLoaded', () => renderApp(document.getElementById('root')))
